import { AttachedObjectResponse } from "@/Common/Models/FileSelection/Responses/AttachedObject";
import { Guid } from "@/Common/Models/Guid";
import { PatientMedicalItemsHelper } from "@/Patient/Helpers/PatientMedicalItemsHelper";
import { MedicalItemTypeEnum } from "@/Patient/Models/MedicalSummary/Enum/MedicalItemTypeEnum";
import { MedicalItem } from "../MedicalItem";
import { FollowUpResponse } from "./FollowUpResponse";

class MedicalItemScreeningTestResponse extends MedicalItem {
    public ScreeningTestProfileId: number;
    public ScreeningTestDefinitionId: number | null;
    public ScreeningTestDefinitionText: string | null;
    public FrequencyTypeDropDownId: string;
    public ReminderTypeDropDownId: string;
    public StatusLookupId: string;
    public InterpretationLookupId: string;
    public InterpretedByEmployee: string;
    public InterpretationDate: Date;
    public DueDate: Date;
    public CompletionDate: Date;
    public CompletedByEmployee: string;
    public StartAge: number;
    public EndAge: number;
    public RequestingStaffContactFacetId: string;
    public Attachments: AttachedObjectResponse[];
    public FollowUps: FollowUpResponse[];

    public constructor(init?: Partial<MedicalItemScreeningTestResponse>) {
        super();
        Object.assign(this, init);
    }

    public static getEmptyScreeningTest(encounterId?: Guid, contactFacetId?: string): MedicalItemScreeningTestResponse {
        const newItem = new MedicalItemScreeningTestResponse();
        PatientMedicalItemsHelper.InitializeEmptyMedicalItem(newItem, MedicalItemTypeEnum.ScreeningTest, encounterId);

        const firstProfile = cacheStore.screeningTestProfiles.firstOrDefault();

        newItem.ScreeningTestProfileId = firstProfile ? firstProfile.Id : null;
        newItem.ScreeningTestDefinitionId = null;
        newItem.ScreeningTestDefinitionText = null;
        newItem.FrequencyTypeDropDownId = "";
        newItem.ReminderTypeDropDownId = "";
        newItem.InterpretationLookupId = "";
        newItem.DueDate = null;
        newItem.CompletionDate = null;
        newItem.StatusLookupId = "";
        newItem.Notes = "";
        newItem.RequestingStaffContactFacetId = contactFacetId ?? "";
        newItem.Attachments = [];
        newItem.FollowUps = [];

        return newItem;
    }
}

class MedicalItemScreeningTestWithLinkResponse extends MedicalItemScreeningTestResponse {
    public HasEvolvedPastLinkEntry: boolean;
    public LinkAddedNewEntry: boolean;
    public IsSignedOff: boolean;
    public LatestEncounterId: string;
    public LatestConsultationDate: Date;
    public IsLatestScreeningTest: boolean;
}

export { MedicalItemScreeningTestResponse, MedicalItemScreeningTestWithLinkResponse };
